import axios from 'axios';
import { useEffect, useState } from 'react';

const useGetBeatInfo = (accessToken, countryCode) => {
  const [beatInfo, setBeatInfo] = useState(null);
  const [error, setError] = useState(null);
  const [isLogin, setIsLogin] = useState(undefined);
  const [hasAccessToken, setHasAccessToken] = useState(undefined);
  const baseURL = process.env.REACT_APP_API_URL_V1;

  useEffect(() => {
    const getBeatInfo = async () => {
      // countryCode 없으면 early return
      if (!countryCode) return;

      // accessToken 있으면 별도 검증을 위해 boolean 값
      if (accessToken) {
        setHasAccessToken(true);
      } else {
        setHasAccessToken(false);
        return;
      }

      try {
        const response = await axios.get(`${baseURL}beat/info?country=${countryCode}`, {
          headers: {
            'os-name': 'Web',
            Authorization: accessToken,
          },
        });
        setIsLogin(true);
        setBeatInfo(response);
      } catch (error) {
        setIsLogin(false);
        setError(error);
      }
    };

    getBeatInfo();
  }, [accessToken, countryCode]);

  return { beatInfo, error, isLogin, hasAccessToken };
};

export default useGetBeatInfo;
